<template>
  <div class="container render2">
    <div class="renderg-title">
      <h2>全自动化客户端</h2>
    </div>
    <el-row  class=" render-list-box flex">
      <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10">
        <ul class="render-client-list">
          <li class="render-client-item" @mouseenter="clientEnter(index)" v-for="(item, index) in clientList" :key="index">
            <div class="render-client-box">
              <p class="render-client" :class="{'active' : active == index}">{{item.title}}</p>
              <p class="render-client-desc">{{item.desc}}</p>
            </div>
          </li>
        </ul>
      </el-col>
      <el-col class="hidden-xs-only flex-align-center" :sm="16" :md="16" :lg="16" :xl="16">
        <ul class="render-image-list">
          <li v-for="(imgItem, index) in imageList" :key="index">
            <div class="client-img" v-show="active == index">
              <el-image class="hidden-lg-and-down" :src="imgItem.image" alt="">
                <div slot="placeholder" class="image-slot">
                  <img :src="imgItem.loadImg" alt="">
                </div>
              </el-image>
              <el-image class="hidden-xl-only hidden-sm-only hidden-xs-only" :src="imgItem.mdLoadImg" alt="">
                <div slot="placeholder" class="image-slot">
                  <img :src="imgItem.loadImg" alt="">
                </div>
              </el-image>
              <el-image class="hidden-xl-only hidden-lg-only hidden-md-only hidden-xs-only" :src="imgItem.smLoadImg" alt="">
                <div slot="placeholder" class="image-slot">
                  <img :src="imgItem.loadImg" alt="">
                </div>
              </el-image>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row >
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      clientList: [
        {
          title: '智能分析',
          desc: '自动分析渲染所需资产文件，按需上传',
        },
        {
          title: '实时预览渲染画面',
          desc: '渲染效果实时查看/控制',
        },
        {
          title: '极速传输',
          desc: '自动分析渲染所需资产文件，按需上传',
        },
        {
          title: '多相机/分层',
          desc: '多相机分层',
        },
      ],
      imageList: [
        {
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/client1.png',
          mdLoadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client1-md.png',
          smLoadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client1-sm.png',
          loadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client1.png',
        },{
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/client2.png',
          mdLoadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client2-md.png',
          smLoadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client2-sm.png',
          // loadImg: require('../../assets/image/loadimg/client2.jpg')
        },{
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/client3.png',
          mdLoadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client3-md.png',
          smLoadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client3-sm.png',
          // loadImg: require('../../assets/image/loadimg/client3.jpg')
        },{
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/client4.png',
          mdLoadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client4-md.png',
          smLoadImg: 'https://cdn.renderg.com/download/www/renderg_dist/images/client4-sm.png',
          // loadImg: require('../../assets/image/loadimg/client4.jpg')
        }

      ]
    }
  },
  methods: {
    clientEnter (index) {
    //  console.log('Enter', index)
      this.active = index
    }
  },
}
</script>